// https://react.i18next.com
// https://www.i18next.com/

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)

  // https://www.robinwieruch.de/react-internationalization

  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false, // Logs info level to console output. Helps finding issues with loading not working

    fallbackLng: 'es',
    // fallbackLng: 'en',
    // lng: 'en', // Language to use (overrides language detection). If set to 'cimode' the output text will be the key

    whitelist: ['es'],
    // whitelist: ['en', 'es'],
    nonExplicitWhitelist: false, // If true will pass 'en-US' if finding 'en' in whitelist

    // Language codes to lookup, given set language is 'en-US'
    // 'all' --> ['en-US', 'en', 'dev']
    // 'currentOnly' --> 'en-US'
    // 'languageOnly' --> 'en'
    load: 'languageOnly',

    // preload: false, // Array of languages to preload. Important on serverside to assert translations are loaded before rendering views
    preload: ['es'],

    // lowerCaseLng: false // Locale will be fully lowercased eg. en-US --> en-us
    cleanCode: true, // Language will be lowercased EN --> en while leaving full locales like en-US

    ns: ['common', 'blog'], // String or array of namespaces to load
    defaultNS: 'common', // Default namespace used if not passed to translation function
    fallbackNS: false,   // String or array of namespaces to lookup key if not found in given namespace

    // https://www.i18next.com/translation-function/interpolation
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',

      // En https://www.robinwieruch.de/react-internationalization está bien explicado
      // Es para ver que traducciones faltan
      // path to post missing resources
      // addPath: '/locales/add/{{lng}}/{{ns}}',

      // allow cross domain requests
      crossDomain: false,
      // allow credentials on cross domain requests
      withCredentials: false,
    },

    detection: {
      // order and from where user language should be detected
      order: ['cookie', 'navigator'], // order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      // El path soy yo el que lo va a forzar
      // order: ['cookie', 'path', 'navigator'], // order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],

      // lookupQuerystring: 'lng',
      lookupCookie: '_i18n',
      lookupFromPathIndex: 0,                 // Para extraerlo de la URL
      // lookupLocalStorage: 'i18nextLng',    // El localStorage debe llamarse así
      // lookupFromSubdomainIndex: 0,
      caches: ['cookie'],                     // Cache user language on // caches: ['localStorage', 'cookie'],

      // optional expire and domain for set cookie
      cookieMinutes: 525600, // Un año
      cookieDomain: 'antarie.com',
      cookieOptions: { path: '/', secure: true, sameSite: 'strict', httpOnly: true },

      // only detect languages that are in the whitelist
      checkWhitelist: true,

      // fallback to a similar whitelist language
      // Example 1: Browser language is 'es'
      // if 'es' is not found in whitelist, first fallback to any whitelist language that starts with 'es-', then fallback to fallbackLng ('es' -> 'es-*' -> fallbackLng)
      // Example 2: Browser language is 'es-MX'
      // if 'es-MX' is not found in whitelist, first fallback to 'es', then fallback to 'es-*', then fallback to fallbackLng ('es-MX' -> 'es' -> 'es-*' -> fallbackLng)
      checkForSimilarInWhitelist: true,
    },

    // https://react.i18next.com/latest/i18next-instance
    react: {
      // bindI18n: 'languageChanged',
      // bindI18nStore: '',
      // transEmptyNodeValue: '',
      // transSupportBasicHtmlNodes: true,
      // transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      // useSuspense: false,
    },
  });

export default i18n;
